import { FC, memo } from 'react';
import { ClinicSettingsDetail } from '../../components/SettingsCalls/ClinicSettingsDetail/ClinicSettingsDetail';

export const ClinicSettingsDetailScreen: FC = memo(() => {
  return <ClinicSettingsDetail />;
});

ClinicSettingsDetailScreen.displayName = 'ClinicSettingsDetailScreen';
